var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nv-app',{attrs:{"navigation":_vm.navigation,"user":{ can: _vm.$auth.hasPermissions },"icon":"/images/dog-icon-120x120.png","title":"DOG"}})
}
var staticRenderFns = []

export { render, staticRenderFns }